(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-brand-collection-grid"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-google-maps"] && !Shopify.designMode) return;
  try {
    
  const loadLazyMap = (container) => {
    if (!container || container.dataset.lazyMapReady === 'true') return;

    const iframe = container.querySelector('iframe[data-src]');
    const placeholder = container.querySelector('[data-map-placeholder]');
    if (!iframe) return;

    container.dataset.lazyMapReady = 'true';
    iframe.src = iframe.dataset.src;
    iframe.removeAttribute('data-src');

    const reveal = () => {
      iframe.classList.remove('nf-google-maps__iframe--pending');
      if (placeholder) placeholder.style.opacity = '0';
    };

    iframe.addEventListener('load', reveal, { once: true });
    window.setTimeout(reveal, 5000);
  };

  const observeLazyMaps = () => {
    const containers = document.querySelectorAll('[data-lazy-map]:not([data-lazy-map-ready])');
    if (containers.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      for (const container of containers) {
        loadLazyMap(container);
      }
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          loadLazyMap(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '50px' }
    );

    for (const container of containers) {
      observer.observe(container);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLazyMaps);
  } else {
    observeLazyMaps();
  }

  document.addEventListener('shopify:section:load', observeLazyMaps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  class NfLogoMarquee extends HTMLElement {
    #viewport = null;
    #active = null;

    connectedCallback() {
      this.#viewport = this.querySelector('.nf-logo-marquee__viewport');
      if (!this.#viewport) return;

      this.#viewport.addEventListener('pointermove', this.#onMove);
      this.#viewport.addEventListener('pointerleave', this.#onLeave);
    }

    disconnectedCallback() {
      if (!this.#viewport) return;
      this.#viewport.removeEventListener('pointermove', this.#onMove);
      this.#viewport.removeEventListener('pointerleave', this.#onLeave);
    }

    #onMove = (event) => {
      const next = this.#itemAt(event.clientX, event.clientY);
      if (next === this.#active) return;

      if (this.#active) this.#active.classList.remove('is-hovered');
      if (next) next.classList.add('is-hovered');
      this.#active = next;
    };

    #onLeave = () => {
      if (this.#active) this.#active.classList.remove('is-hovered');
      this.#active = null;
    };

    #itemAt(x, y) {
      const items = this.querySelectorAll('.nf-logo-marquee__item');

      for (const item of items) {
        const rect = item.getBoundingClientRect();
        if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
          return item;
        }
      }

      return null;
    }
  }

  if (!customElements.get('nf-logo-marquee')) {
    customElements.define('nf-logo-marquee', NfLogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-nearest-locations"] && !Shopify.designMode) return;
  try {
    
  const CLOSED_TOKENS = ['gesloten', 'closed', 'geschlossen', 'fermé', 'ferme'];
  const APPOINTMENT_TOKENS = ['op afspraak', 'by appointment', 'nach vereinbarung', 'sur rendez-vous', 'sur rendezvous'];
  const OPENING_SOON_MINUTES = 90;
  const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  const distanceKm = (lat1, lon1, lat2, lon2) => {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2
      + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const timeToMinutes = (time) => {
    const [hour, minute = 0] = String(time).split(':').map(Number);
    return hour * 60 + minute;
  };

  const amsterdamNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const read = (type) => parts.find((part) => part.type === type)?.value;
    const hour = Number(read('hour'));
    const minute = Number(read('minute'));
    return {
      weekday: String(read('weekday') || '').toLowerCase(),
      minutes: hour * 60 + minute,
    };
  };

  const statusFromHours = (hours, minutesNow) => {
    const normalized = String(hours ?? '').trim().toLowerCase();
    if (normalized === '' || CLOSED_TOKENS.includes(normalized)) {
      return { status: 'closed' };
    }
    if (APPOINTMENT_TOKENS.includes(normalized)) {
      return { status: 'appointment' };
    }

    const ranges = String(hours)
      .split(/\s*,\s*|\s+en\s+/i)
      .map((range) => {
        const [start, end] = range.split(/\s*-\s*/).map((part) => part.trim());
        if (!start || !end) return null;
        return { start: timeToMinutes(start), end: timeToMinutes(end), endStr: end };
      })
      .filter(Boolean);

    for (const range of ranges) {
      if (minutesNow >= range.start && minutesNow <= range.end) {
        return { status: 'open', time: range.endStr };
      }
    }

    // "Binnenkort open" from 1.5 hours before a block starts.
    for (const range of ranges) {
      const minutesUntilOpen = range.start - minutesNow;
      if (minutesUntilOpen > 0 && minutesUntilOpen <= OPENING_SOON_MINUTES) {
        return { status: 'opening-soon' };
      }
    }

    return { status: 'closed' };
  };

  const COUNTRY_PART = /^(belgi[eë]|belgium|deutschland|germany|nederland|netherlands|france|frankrijk|luxembourg|luxemburg)$/i;

  const cityFromAddress = (address) => {
    const parts = String(address ?? '')
      .split(/[\n,]/)
      .map((part) => part.trim())
      .filter((part) => part && !COUNTRY_PART.test(part));

    for (const part of parts) {
      const dutch = part.match(/\b\d{4}\s?[A-Za-z]{2}\s+(.+)$/);
      if (dutch?.[1]) return dutch[1].trim();

      const numeric = part.match(/\b\d{4,5}\s+(.+)$/);
      const numericCity = numeric?.[1]?.trim() || '';
      if (numericCity && !/^[A-Za-z]{2}$/.test(numericCity)) return numericCity;
    }

    for (let index = 0; index < parts.length - 1; index += 1) {
      if (/^\d{4}\s?[A-Za-z]{2}$/.test(parts[index]) || /^\d{4,5}$/.test(parts[index])) {
        return parts[index + 1];
      }
    }

    return parts[parts.length - 1] || '';
  };

  const loadMaps = (key) => {
    if (window.google?.maps?.DistanceMatrixService) {
      return Promise.resolve(true);
    }
    if (!key) return Promise.resolve(false);

    const existing = document.querySelector('script[data-nf-maps-distance]');
    if (existing) {
      return new Promise((resolve) => {
        if (window.google?.maps?.DistanceMatrixService) {
          resolve(true);
          return;
        }
        existing.addEventListener('load', () => resolve(Boolean(window.google?.maps?.DistanceMatrixService)), { once: true });
        existing.addEventListener('error', () => resolve(false), { once: true });
      });
    }

    return new Promise((resolve) => {
      const callbackName = `nfNearestMapsReady${Date.now()}`;
      window[callbackName] = () => {
        delete window[callbackName];
        resolve(Boolean(window.google?.maps?.DistanceMatrixService));
      };
      const script = document.createElement('script');
      script.async = true;
      script.dataset.nfMapsDistance = 'true';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&callback=${callbackName}`;
      script.addEventListener('error', () => {
        delete window[callbackName];
        resolve(false);
      }, { once: true });
      document.head.appendChild(script);
    });
  };

  const drivingDistances = (origin, stores) => new Promise((resolve) => {
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix({
      origins: [{ lat: origin.lat, lng: origin.lng }],
      destinations: stores.map((store) => ({ lat: store.lat, lng: store.lng })),
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
    }, (response, status) => {
      if (status !== 'OK' || !response?.rows?.[0]) {
        resolve(null);
        return;
      }
      const distances = new Map();
      response.rows[0].elements.forEach((element, index) => {
        if (element?.status === 'OK' && element.distance?.value != null) {
          distances.set(stores[index].id, element.distance.value / 1000);
        }
      });
      resolve(distances);
    });
  });

  class NfNearestLocations extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-nearest-source]');
      if (!source) return;

      let data;
      try {
        data = JSON.parse(source.textContent);
      } catch {
        return;
      }

      const originLat = Number(data?.origin?.lat);
      const originLng = Number(data?.origin?.lng);
      if (!Number.isFinite(originLat) || !Number.isFinite(originLng)) return;

      const stores = (data.stores || [])
        .map((store) => {
          const lat = Number(store.lat);
          const lng = Number(store.lng);
          if (!Number.isFinite(lat) || !Number.isFinite(lng) || !store.url || !store.name) return null;
          return {
            ...store,
            lat,
            lng,
            km: distanceKm(originLat, originLng, lat, lng),
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.km - b.km);

      if (!stores.length) return;

      this.#paint(stores.slice(0, 3));
      this.#refineWithDrivingDistance({ lat: originLat, lng: originLng }, stores);
    }

    #statusLabel(store) {
      const now = amsterdamNow();
      const weekday = WEEKDAYS.includes(now.weekday) ? now.weekday : 'monday';
      const result = statusFromHours(store.hours?.[weekday], now.minutes);
      if (result.status === 'open') {
        const template = this.dataset.openTemplate || 'Open until __TIME__';
        return template.replace('__TIME__', result.time);
      }
      if (result.status === 'appointment') {
        return this.dataset.appointmentLabel || '';
      }
      if (result.status === 'opening-soon') {
        return this.dataset.openingSoonLabel || '';
      }
      return this.dataset.closedLabel || '';
    }

    #meta(store) {
      const city = String(store.city || '').trim() || cityFromAddress(store.address);
      const kmLabel = `${Math.max(1, Math.round(store.km))} km`;
      const status = this.#statusLabel(store);
      return [city, kmLabel, status].filter(Boolean).join(' · ');
    }

    #paint(stores) {
      const grid = this.querySelector('[data-nearest-grid]');
      if (!grid) return;

      grid.replaceChildren();
      for (const store of stores) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'nf-nearest-locations__card';
        link.href = store.url;

        const name = document.createElement('span');
        name.className = 'nf-nearest-locations__name';
        name.textContent = store.name;

        const meta = document.createElement('span');
        meta.className = 'nf-nearest-locations__meta';
        meta.textContent = this.#meta(store);

        link.append(name, meta);
        item.append(link);
        grid.append(item);
      }

      grid.hidden = false;
    }

    async #refineWithDrivingDistance(origin, stores) {
      const key = this.dataset.apiKey;
      if (!key) return;

      const loaded = await loadMaps(key);
      if (!loaded || !this.isConnected) return;

      const candidates = stores.slice(0, 25);
      const distances = await drivingDistances(origin, candidates);
      if (!distances || !this.isConnected) return;

      const ranked = stores
        .map((store) => ({
          ...store,
          km: distances.has(store.id) ? distances.get(store.id) : store.km,
        }))
        .sort((a, b) => a.km - b.km);

      this.#paint(ranked.slice(0, 3));
    }
  }

  if (!customElements.get('nf-nearest-locations')) {
    customElements.define('nf-nearest-locations', NfNearestLocations);
  }

  } catch(e) { console.error(e); }
})();
})();
